'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('ProviderTermsOfUseCtrl', ProviderTermsOfUseCtrl);

  ProviderTermsOfUseCtrl.$inject = ['$scope', '$stateParams', '$sce', 'msAuth', 'userSvc', 'providerSvc', 'onboardingRouter'];

  function ProviderTermsOfUseCtrl($scope, $stateParams, $sce, msAuth, userSvc, providerSvc, onboardingRouter) {
    var preferences;
    var provider = providerSvc.getProvider();
    providerSvc.getPreferences().then(function (prefs) {
      preferences = prefs;
      if (provider && provider.organization) {
        $scope.cobrandingText = provider.organizationFullName ? provider.organizationFullName : provider.organization.name;
        if (preferences.customTermsOfUse) {
          //set the custom terms of use
          $scope.termsOfUseHtml = $sce.trustAsHtml(preferences.customTermsOfUse);
        }
        providerSvc.getHeaderImage().then(function (data) {
          if (data) {
            $scope.cobranding = data;
          }
        });
      } else {
        $scope.cobrandingText = '';
      }
    });

    $scope.navigate = function () {
      if (!$scope.form.$valid) {
        // scroll to the title
        $('h2')[0].scrollIntoView(true);
        // if the form is not valid, mark the invalid fields
        angular.forEach($scope.form, function (formElement) {
          if (formElement && formElement.hasOwnProperty('$dirty')) {
            formElement.$dirty = true;
          }
        });
        return;
      }
      providerSvc.acknowledgeCustomTermsOfUse();
      if (msAuth.isLoggedIn()) {
        userSvc.getUser().then(function (user) {
          if (user) {
            var userPreferences = angular.extend({
              agreedToOrganizationTermsAndConditions: true
            }, user.userPreferences);
            userSvc.savePreferences(userPreferences);
          }
        })['finally'](function () {
          onboardingRouter.goToNextStep($stateParams);
        });
      } else {
        onboardingRouter.goToNextStep($stateParams);
      }
    };
  }
})();